import { createFeatureSelector } from '@ngrx/store';

export interface ISheetViewState {
    isOpen: boolean;
    optionGroupId: string;
}

export const sheetViewInitialState: ISheetViewState = {
    isOpen: false,
    optionGroupId: '',
};

export const sheetViewStateKey = 'optionSheetView';

export const sheetViewStateSelector = createFeatureSelector<ISheetViewState>(sheetViewStateKey);
